<template>
    <div id="create-account-hero">
        <div class="row m-0" style="width:100%;">
            <div class="col-lg-5 p-0">
                <div class="d-none d-lg-block">
                    <div class="row" id="left-div">
                        <div class="col-md-6" id="cover-img"></div>
                        <div class="col-md-6 p-5 cover-info">
                            <div>
                                <h1 class="mb-5">BECOME A WILDLIFE HERO</h1>
                                <h2 class="mb-4">
                                    JOIN THE WILDLIFE PROTECTOR PRIVATE
                                    MEMBERSHIP
                                </h2>
                                <p>
                                    Become a wildlife Hero by sponsoring
                                    equipment and tools to the team on the
                                    ground so you can protect the endangered
                                    tigers and safeguard their homes!
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h1 class="mb-5 mt-5 p-1">BECOME A WILDLIFE HERO</h1>
                </div>
            </div>
            <div class="col-lg-7 p-0" id="create-form">
                <header class="site-header">
                    <div class="container">
                        <nav
                            class="navbar navbar-expand-lg navbar-light navbar-offcanvas py-0"
                        >
                            <a class="navbar-brand" href="/">
                                <img
                                    class="navbar-logo"
                                    src="/images/WWF_Logo.jpg"
                                />
                            </a>
                        </nav>
                    </div>
                </header>
                <div class="row p-3" style="width:100%;">
                    <div class="col-md-2 "></div>
                    <div class="col-md-8 p-0">
                        <div
                            class="card-body p-5 mt-md-5"
                            v-bind:class="{ 'd-none': create_success }"
                        >
                            <h1 class="mb-4">CREATE YOUR PRIVATE ACCOUNT</h1>
                            <form
                                @submit.prevent="validateInfoAndCreateAccount"
                                class=""
                            >
                                <div class="row">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>First name</label>
                                            <input
                                                id="firstname"
                                                type="text"
                                                class="form-control"
                                                value=""
                                                name="firstname"
                                                v-model="fields.firstname"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.firstname
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.firstname"
                                            >
                                                <strong>{{
                                                    errors.firstname
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Last name</label>
                                            <input
                                                id="lastname"
                                                type="text"
                                                class="form-control"
                                                name="lastname"
                                                v-model="fields.lastname"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.lastname
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.lastname"
                                            >
                                                <strong>{{
                                                    errors.lastname
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Email address</label>
                                            <input
                                                id="email"
                                                type="email"
                                                class="form-control"
                                                name="email"
                                                placeholder="example@email.com"
                                                v-model="fields.email"
                                                v-bind:class="{
                                                    'is-invalid': errors.email
                                                }"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.email"
                                            >
                                                <strong>{{
                                                    errors.email
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Phone number</label>
                                            <vue-tel-input
                                                class="form-control"
                                                name="phone"
                                                v-model="fields.phone"
                                                v-on:input="validate"
                                                v-bind:class="{
                                                    'is-invalid': errors.phone
                                                }"
                                            ></vue-tel-input>
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.phone"
                                            >
                                                <strong>{{
                                                    errors.phone
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Password</label>
                                            <input
                                                id="password"
                                                type="password"
                                                class="form-control"
                                                name="password"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.password
                                                }"
                                                placeholder="Password"
                                                v-model="fields.password"
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="errors.password"
                                            >
                                                <strong>{{
                                                    errors.password
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label>Confirm password</label>
                                            <input
                                                id="password_confirmation"
                                                type="password"
                                                class="form-control"
                                                name="password_confirmation"
                                                v-bind:class="{
                                                    'is-invalid':
                                                        errors.password_confirmation
                                                }"
                                                autofocus
                                                placeholder="Password"
                                                v-model="
                                                    fields.password_confirmation
                                                "
                                            />
                                            <span
                                                class="invalid-feedback"
                                                role="alert"
                                                v-if="
                                                    errors.password_confirmation
                                                "
                                            >
                                                <strong>{{
                                                    errors.password_confirmation
                                                }}</strong>
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-md-12">
                                        I agree to WWF-Singapore's
                                        <a
                                            href="https://www.wwf.sg/wwf_singapore/pdp_policy"
                                            class="personal-data-protection-policy"
                                            >Personal Data Protection Policy.</a
                                        >.
                                        <p>
                                            By creating an account, I agree to
                                            receive updates from WWF-Singapore
                                            in accordance with our
                                            <a
                                                href="https://www.wwf.sg/wwf_singapore/pdp_policy"
                                                class="personal-data-protection-policy"
                                                >Personal Data Protection
                                                Policy.</a
                                            >
                                        </p>
                                    </div>
                                </div>

                                <div class="form-group row mb-0 mt-3">
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4"></div>
                                    <div class="col-md-4">
                                        <button
                                            type="submit"
                                            class="btn btn-primary form-control"
                                        >
                                            NEXT
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div
                            class="card-body p-5 d-none"
                            v-bind:class="{ 'd-block': create_success }"
                        >
                            <h1 class="mb-4">
                                CONGRATS! YOU ARE NOW A WILDLIFE OBSERVER!
                            </h1>
                            <div class="row">
                                <div class="col-md-12">
                                    <p>
                                        Become a wildlife Hero by sponsoring
                                        equipment and tools for the team on the
                                        ground to protect the endangered
                                        wildlife and safeguard their homes!
                                    </p>
                                </div>
                                <div class="col-md-12 text-center mt-3">
                                    <img
                                        width="100"
                                        height="100"
                                        :src="
                                            '/storage/imgs/assets/loading.gif'
                                        "
                                    />
                                </div>
                                <div class="col-md-12">
                                    <p class="text-center" id="loading-message">
                                        Please wait while we redirect you to
                                        your account...
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2"></div>
                </div>
            </div>
            <div class="col-12 p-0">
                <div class="cover-info text-center mt-5 d-block d-lg-none">
                    <h2 class="mb-1 p-1">
                        JOIN THE WILDLIFE PROTECTOR PRIVATE COMMUNITY
                    </h2>
                    <p class="mb-2 p-5">
                        Become a wildlife Hero by sponsoring equipment and tools
                        to the team on the ground so you can protect the
                        endangered wildlife and safeguard their homes!
                    </p>
                    <div id="cover-img" style="height:80vh; width:100%;"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["token", "utm"],
    data() {
        return {
            fields: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                password: "",
                hero: true,
                donor: false,
                password_confirmation: "",
                clean_phone_format: "",
                _token: this.token
            },
            create_success: "",
            errors: {
                firstname: "",
                lastname: "",
                email: "",
                phone: "",
                password: "",
                password_confirmation: ""
            }
        };
    },
    create() {
        console.log(this.utm);
    },
    methods: {
        validate(number, result) {
            this.errors.phone = result.isValid
                ? ""
                : "The phone number is invalid.";
            this.fields.clean_phone_format = result.isValid
                ? result.number.e164.replace("+", "")
                : "";
        },
        validateInfoAndCreateAccount() {
            fetch("/create-account-observer/validate-fields", {
                method: "post",
                body: JSON.stringify(this.fields),
                headers: {
                    "content-type": "application/json",
                    Accept: "application/json"
                }
            })
                .then(res => res.json())
                .then(res => {
                    if (typeof res.errors != "undefined") {
                        this.errors.firstname =
                            typeof res.errors.firstname != "undefined"
                                ? res.errors.firstname[0]
                                : "";
                        this.errors.lastname =
                            typeof res.errors.lastname != "undefined"
                                ? res.errors.lastname[0]
                                : "";
                        this.errors.email =
                            typeof res.errors.email != "undefined"
                                ? res.errors.email[0]
                                : "";
                        this.errors.phone =
                            typeof res.errors.phone != "undefined"
                                ? res.errors.phone[0]
                                : this.errors.phone != ""
                                ? "The phone number is invalid."
                                : "";
                        this.errors.password =
                            typeof res.errors.password != "undefined"
                                ? res.errors.password[0]
                                : "";
                        this.errors.password_confirmation =
                            typeof res.errors.password_confirmation !=
                            "undefined"
                                ? res.errors.password_confirmation[0]
                                : "";
                    }
                    if (res.status == "success") {
                        this.create_success = "success";
                        setTimeout(window.location.replace("/user"), 10000);
                    }
                })
                .catch(err => console.log(err));
        }
    }
};
</script>

<style scoped>
header {
    background-color: transparent;
    position: absolute;
    width: 100%;
    top: 0;
}
#create-account-hero {
    margin: 0;
    padding: 0;
    min-width: 100%;
    min-height: 90vh;
}
#create-account-hero #left-div {
    padding: 0;
    background-color: black;
    min-height: 90vh;
}
#create-account-hero #left-div .col-6 {
    padding: 0;
}
#cover-img {
    background-image: url("/images/pages/checkout/Vertical-Join-Wildlife-Observer.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    height: 100vh;
}
.cover-info,
#create-form {
    display: flex;
    justify-content: center;
    align-items: center;
}
.cover-info h1 {
    color: #ffca00;
    font-size: 3em;
    margin-bottom: 1.5rem !important;
}
.cover-info h2 {
    color: white;
    font-size: 2rem;
}
.cover-info p {
    color: white;
    font-size: 1rem;
}
.cover-info h1,
.cover-info h2 {
    font-family: "WWF";
    line-height: 1;
}
#create-form .card-body {
    box-shadow: 0.2px 0.2px 20px gray;
    border-radius: 3px;
    background-color: white;
}
#create-form .card-body h1 {
    font-family: "WWF";
    font-size: 3em;
    text-align: left;
    line-height: 1;
}
#create-form button {
    background-color: #f58220;
    border: none;
    font-weight: bolder;
}
.personal-data-protection-policy {
    color: #f58220;
}
#loading-message {
    color: #f58220;
}
label {
    font-weight: 400 !important;
    font-family: "Open Sans";
    font-size: 0.9rem;
}

/* SMALL DEVICES */
@media only screen and (min-width: 600px) {
}
/* MEDIUM DEVICES */
@media only screen and (max-width: 992px) {
    #create-account-hero {
        background-color: black;
    }
    header {
        display: none;
    }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type="number"] {
    -moz-appearance: textfield;
}
</style>
